import React from 'react';
import Card, { CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { useAdminData } from '../../context/AdminDataContext';
import { useRole } from '../../context/RoleContext';

const Payroll: React.FC = () => {
  const { activeCompanyId } = useRole();
  const { clients } = useAdminData();

  const activeClient = clients.find((client) => client.id === activeCompanyId) ?? clients[0] ?? null;

  return (
    <div className="space-y-6">
      <section className="admin-page-header">
        <div>
          <h1 className="text-3xl font-semibold">Payroll</h1>
          <p className="mt-1 text-sm text-[var(--admin-muted)]">
            Payroll readiness summary for {activeClient?.name ?? 'the selected client'}.
          </p>
        </div>
      </section>

      <Card>
        <CardHeader>
          <CardTitle>Module Unavailable</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-[var(--admin-muted)]">
          <p>The backend does not currently expose an admin payroll summary endpoint.</p>
          <p>No request is sent until that contract exists, so the dashboard will not rely on invented response fields.</p>
          <div className="rounded-2xl border border-[var(--admin-amber)] bg-[var(--admin-amber-soft)] px-4 py-3">
            Required backend capability: payroll summary for client {activeClient?.id ?? 'not selected'}.
          </div>
        </CardContent>
      </Card>

      <Card className="border-[var(--admin-amber)] bg-[var(--admin-amber-soft)]">
        <CardHeader>
          <CardTitle>Write Actions Disabled</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-[var(--admin-muted)]">
          Send/Download payroll actions remain disabled until backend export and dispatch endpoints exist.
        </CardContent>
      </Card>
    </div>
  );
};

export default Payroll;
